// import React from "react";
// import './App.css';
// import Home from './Components/Home/Home.js';
// import Header from './Components/header/Header';
// import { Routes, Route } from "react-router-dom";
// import OrderPage from "./Components/order/OrderPage.js";




// function App() {
//   return (

//     <div>
  
//     <Header />
//     <Routes>

//     <Route path='/' element={ <Home /> }  />  
     
//     <Route path="/order/:id" element={<OrderPage />} />

    

//     </Routes>
   
   
//     </div>
//   )

// }

// export default App;
import React from "react";
import './App.css';
import Home from './Components/Home/Home.js';
import Header from './Components/header/Header';
import { Routes, Route } from "react-router-dom";
import OrderPage from "./Components/order/OrderPage.js";
import DetailsPage from "./Components/Details/DetailsPage.js";

function App() {
  return (
    <div>

      <Header />

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/product/:id' element={<DetailsPage />} />
        <Route path='/order/:id' element={<OrderPage />} />
      </Routes>

    </div>
  );
}

export default App;